module.exports = __webpack_public_path__ + "e6890f99e3696f5a50a27abb8454da7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cyberponics_logo.png
// module id = 476
// module chunks = 0